import { adminServerInstance } from "../axios/instances";
import { 
    GET_POST_CODE_IN_POLYGON,
    GET_POST_CODE_IN_POLYGON_SUCCESS,
    GET_POST_CODE_IN_POLYGON_FAIL,
    GET_POST_CODE_IN_CIRCLE,
    GET_POST_CODE_IN_CIRCLE_SUCCESS,
    GET_POST_CODE_IN_CIRCLE_FAIL
} from './types';

export function getPostCodeInPolygon(bounds){
    return function(dispatch){
        dispatch({type: GET_POST_CODE_IN_POLYGON})
        return adminServerInstance.get(`/map/getpostcodeinpolygon?polygon=${bounds}`)
        .then(({data}) => {
            dispatch({
                type: GET_POST_CODE_IN_POLYGON_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: GET_POST_CODE_IN_POLYGON_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getPostCodeInCircle(oPoint, radius){
    return function(dispatch){
        dispatch({type: GET_POST_CODE_IN_CIRCLE})
        return adminServerInstance.get(`/map/getpostcodeincircle?oPoint=${oPoint}&radius=${radius}`)
        .then(({data}) => {
            dispatch({
                type: GET_POST_CODE_IN_CIRCLE_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: GET_POST_CODE_IN_CIRCLE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}
